module.exports = __webpack_public_path__ + "img/timer.c18c825e.gif";